import { ArrowRight, CircleCheckFilled } from 'baseui/icon'
import type { CreditBoosterQuest } from '@/containers/SubscriptionFormPageNew/Components/CreditBooster/useCreditBoosterContent'
import CreditIcon from '@/containers/SubscriptionFormPageNew/Components/CreditBooster/selectra_check.svg'
import {
  CreditChip,
  CreditChipIcon,
  QuestArrow,
  QuestBody,
  QuestCheck,
  QuestHint,
  QuestIcon,
  QuestRow,
  QuestTitle,
} from '@/containers/SubscriptionFormPageNew/Components/CreditBooster/SaleQuest/styled-components'

interface SaleQuestRowProps {
  quest: CreditBoosterQuest
}

const SaleQuestRow = ({ quest }: SaleQuestRowProps) => (
  <QuestRow type='button' data-sale={quest.name} $sold={quest.sold} disabled={quest.sold} onClick={quest.onOpen}>
    <QuestIcon $sold={quest.sold}>
      {quest.iconNode}
      <QuestCheck $hidden={!quest.sold}>
        <CircleCheckFilled size={16} />
      </QuestCheck>
    </QuestIcon>
    <QuestBody>
      <QuestTitle $sold={quest.sold}>{quest.title}</QuestTitle>
      <QuestHint $sold={quest.sold} hidden={!quest.hint}>
        {quest.hint}
      </QuestHint>
    </QuestBody>
    <CreditChip $sold={quest.sold} $hidden={quest.creditsHidden}>
      {quest.sold ? <CircleCheckFilled size={14} /> : <CreditChipIcon src={CreditIcon} alt='' />}+{quest.credits}
    </CreditChip>
    <QuestArrow $hidden={quest.sold}>
      <ArrowRight size={18} />
    </QuestArrow>
  </QuestRow>
)

export default SaleQuestRow
